import CompanyDashboard from './CompanyDashboard';

export default CompanyDashboard;
